import React from 'react';
import { Grid, FormControl, InputLabel, TextField } from '@mui/material';

const DateInputComponent2 = ({ formData, handleDateChange, handleInputChange, handleInputComplete, styled, inputStyles, isDesktop, field }) => {
    return (
        <Grid item xs={12} md={6} key={field.name}>
            <Grid container alignItems="center" spacing={1}>
                <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                    <InputLabel htmlFor={field.name}>{field.label}:</InputLabel>

                </Grid>
                <Grid item xs>
                    <FormControl fullWidth>
                        {field.type === 'date' ? (
                            <TextField
                                id={field.name}
                                name={field.name}
                                type="date"
                                value={formData[field.name]}
                                onChange={handleDateChange}
                                inputProps={{ style: styled.cutDate }}
                                sx={inputStyles}
                            />
                        ) : (
                            <TextField
                                id={field.name}
                                name={field.name}
                                value={formData[field.name]}
                                onChange={(e) => handleInputChange(e)}
                                // onBlur={(e) => handleInputComplete(e)}
                                inputProps={{ style: styled.input, readOnly: field.type === 'readOnly' }}
                                sx={inputStyles}
                                onKeyDown={(e) => {
                                    if (e.key === "Tab" || e.key === "Enter") {
                                        handleInputComplete(e); // Trigger calculation when "Enter" is pressed
                                    }
                                }}
                            />
                        )}
                    </FormControl>
                </Grid>
            </Grid>
        </Grid>
    );
};

export default DateInputComponent2;
